<div
    *ngIf="showAlert && shouldDisplayComponent"
    class="alert-bar-wrapper"
    [ngStyle]="{
        'background-color': windowSize.isSmallDevice
            ? alertData.mobile_background_color
            : alertData.background_color
    }"
>
    <div class="container">
        <div class="alert-bar">
            <div *ngIf="alertData.text" class="message">
                {{ alertData.text }}
            </div>
            <div *ngIf="alertData.link && alertData.call_to_action" class="link">
                <a [ngStyle]="{ color: alertData.text_color }" [href]="alertData.link">
                    {{ alertData.call_to_action }}
                    <app-icon [type]="'Arrow-right'"></app-icon>
                </a>
            </div>
            <div class="close-alert" (click)="close()">
                <app-icon [type]="'Close'"></app-icon>
            </div>
        </div>
    </div>
</div>
